import React, { useState, useEffect } from "react";
import styles from "./catalog.module.css";
import { useParams, useLocation, useNavigate, Link } from "react-router-dom";
import { SET_PATH_PARAMS } from "../../services/actions/path_params_actions";
import SwitcherCatProd from "../../components/switcher_cat_prod/switcher_cat_prod";
import { getDataFromCatalogRoutes, setMetaTags, deepFindBySlug } from "../../utils/util_functions";
import { useSelector, useDispatch } from "react-redux";
import {
  getRoutes, getLoading, getProducts, getCategories, getSaleProducts, getNewProducts
} from "../../services/selectors";
import Loader from "../../components/loader/loader";
import MenuContainer from "../../components/categories_menu/menu_container/menu_container";
import categoryImage from "../../images/category.png";
import ProductCard from "../../components/product_card/product_card";
import { PRODUCTS_IN_PAGE } from "../../utils/constants";
import ProductsList from "../../components/products_list/products_list";



function Catalog() {

  let { slug1, slug2, slug3, slug4 } = useParams();
  const slugCategory = slug4 ? slug4 : slug3 ? slug3 : slug2 ? slug2 : slug1;

  const isLoading = useSelector(getLoading);
  const products = useSelector(getProducts);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [checkProd, setCheckProd] = useState(true);
  const [actualProducts, setActualProducts] = useState([]);



  const { categories } = useSelector(getCategories);
  const routes = useSelector(getRoutes);


  const {
    metaTitle, metaDescription, metaKeywords, metaRobots
  } = getDataFromCatalogRoutes(location.pathname, navigate, routes, slug1);

  const [childrenCategories, setChildrenCategories] = useState(categories);

  // useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, [location]);
  useEffect(() => {window.scrollTo({ top: 0, left: 0 })}, []);

  useEffect(() => {

    dispatch({
      type: SET_PATH_PARAMS,
      uid: '',
      token: '',
      slug1: slug1 || '',
      slug2: slug2 || '',
      slug3: slug3 || '',
      slug4: slug4 || ''
    });
    // eslint-disable-next-line
  }, [location]);



  useEffect(() => {
    setMetaTags(metaTitle, metaDescription, metaKeywords, metaRobots);
    // eslint-disable-next-line
  }, [metaTitle, metaDescription, metaKeywords, metaRobots]);

  const handleChecked = () => {
    setCheckProd(!checkProd);
  }

  const saleProducts = useSelector(getSaleProducts);
  const newProducts = useSelector(getNewProducts);


  useEffect(() => {
    if (location.pathname === '/catalog') {
      setChildrenCategories(categories);
      setActualProducts([...products.filter(product => product.category === null && product.in_archive === false)]);
    } else {
      if (
        routes.some(
          route => route.path.includes('/catalog/') &&
            route.path !== '/catalog/sale' &&
            route.path !== '/catalog/new'
        ) &&
        !isLoading &&
        !routes.find(r => r.path === location.pathname)
      ) {
        navigate('/not-found', { replace: true });
      }

      if (location.pathname === '/catalog/sale') {
        setChildrenCategories(deepFindBySlug(categories, slugCategory)?.children || []);
        setActualProducts(saleProducts);
      } else if (location.pathname === '/catalog/new') {
        setChildrenCategories(deepFindBySlug(categories, slugCategory)?.children || []);
        setActualProducts(newProducts);
      } else {
        setChildrenCategories(deepFindBySlug(categories, slugCategory)?.children || []);
        setActualProducts(
          [...products.filter(
            product => product.category === slugCategory && product.in_archive === false
          )]
        );
      }

    }
    if (childrenCategories.length) {
      setCheckProd(false);
    } else {
      setCheckProd(true);
    }
    // eslint-disable-next-line
  }, [childrenCategories, location.pathname, products]);


  return (
    <main className='main main__sw main__colons' >
      {isLoading && <Loader />}
      <MenuContainer />
      <div className="main_content">
        <SwitcherCatProd
          checkProd={checkProd}
          handleChecked={handleChecked}
          visible={childrenCategories.length > 0 && actualProducts.length > 0}
        />
        {checkProd === true && actualProducts.length > 0 &&
          <ProductsList actualProducts={actualProducts} />
        }
        {checkProd === false && childrenCategories.length > 0 &&
          <ul className={styles.list}>
            {childrenCategories.map((category) => {
              if (category.slug !== 'sale' && category.slug !== 'new') {
                return (
                  <li key={category.id}>
                    <Link to={category.path}
                      className={styles.categoryCard}
                    >
                      {category.name}
                      <img
                        alt={category.name} className={styles.img}
                        src={category.image ? category.image : categoryImage}
                      />
                    </Link>
                  </li>
                )
              } else if (category.slug === 'sale' && saleProducts.length) {
                return (
                  <li key={category.id}>
                    <Link to={category.path}
                      className={styles.saleNewCard}
                    >
                      {category.name}
                    </Link>
                  </li>
                )
              } else if (category.slug === 'new' && newProducts.length) {
                return (
                  <li key={category.id}>
                    <Link to={category.path}
                      className={styles.saleNewCard}
                    >
                      {category.name}
                    </Link>
                  </li>
                )
              }
              return null;
            })}
          </ul>
        }
      </div>

    </main>
  );



  // return (
  //   <main className='main main__sw main__colons' >
  //     {isLoading ? <Loader /> :
  //       <>
  //         <MenuContainer />
  //         <div className="main_content">
  //           <SwitcherCatProd
  //             checkProd={checkProd}
  //             handleChecked={handleChecked}
  //             visible={childrenCategories.length > 0 && actualProducts.length > 0}
  //           />
  //           {checkProd === true && actualProducts.length > 0 &&
  //             <ProductsList actualProducts={actualProducts} />
  //           }
  //           {checkProd === false && childrenCategories.length > 0 &&
  //             <ul className={styles.list}>
  //               {childrenCategories.map((category) => {
  //                 if (category.slug !== 'sale' && category.slug !== 'new') {
  //                   return (
  //                     <li key={category.id}>
  //                       <Link to={category.path}
  //                         className={styles.categoryCard}
  //                       >
  //                         {category.name}
  //                         <img
  //                           alt={category.name} className={styles.img}
  //                           src={category.image ? category.image : categoryImage}
  //                         />
  //                       </Link>
  //                     </li>
  //                   )
  //                 } else if (category.slug === 'sale' && saleProducts.length) {
  //                   return (
  //                     <li key={category.id}>
  //                       <Link to={category.path}
  //                         className={styles.saleNewCard}
  //                       >
  //                         {category.name}
  //                       </Link>
  //                     </li>
  //                   )
  //                 } else if (category.slug === 'new' && newProducts.length) {
  //                   return (
  //                     <li key={category.id}>
  //                       <Link to={category.path}
  //                         className={styles.saleNewCard}
  //                       >
  //                         {category.name}
  //                       </Link>
  //                     </li>
  //                   )
  //                 }
  //                 return null;
  //               })}
  //             </ul>
  //           }
  //         </div>
  //       </>
  //     }
  //   </main>
  // );
}
export default Catalog;
